import { PageConsent } from './PageConsent';

export default PageConsent;
